import { Component, OnInit,Input,EventEmitter,Output} from '@angular/core';
import{ContentManagementService} from '../../../Services/content-management/content-management.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from "ngx-toastr";
import { ChangeDetectorRef } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import {AppOfflineStore} from '../../../app.offlineService';
import { FormControl, Validators } from '@angular/forms';
import { StudyMaterialReportModel } from 'src/app/Models/StudyMaterial';
import { StudyMaterialActivityHistory } from 'src/app/Models/StudyMaterial';
import { Subject } from 'rxjs';
import{ContentReviewcommentsComponent} from '../content-reviewcomments/content-reviewcomments.component'
@Component({
  selector: 'app-content-studymaterialreports',
  templateUrl: './content-studymaterialreports.component.html',
  styleUrls: ['./content-studymaterialreports.component.css']
})
export class ContentStudymaterialreportsComponent implements OnInit {
  Close:Subject<any> = new Subject();
  Replace:Subject<any> = new Subject();
  Close1:Subject<any> = new Subject();
  Replace1:Subject<any> = new Subject();
  Closeclear:Subject<any> = new Subject();
  Replaceclear:Subject<any> = new Subject();
  ScreenName1:string;
  lanuage:any;
  MajorTopic:MajorTopic[]=[];
  Studymaterialreport:StudyMaterialReportModel;
  StudyMaterialReportform = new FormGroup({
    SubjectID: new FormControl(''),
    MajorTopicID: new FormControl('')
  })
  constructor(public appser:AppOfflineStore,public Activeroute:ActivatedRoute,private cdr: ChangeDetectorRef,public service:ContentManagementService,private fb: FormBuilder,private toastr: ToastrService) {
    this.lanuage=this.appser.dataStore[0].Language;
    // this.getsubject(null,null);

    // this.ScreenName1==this.Activeroute.snapshot.paramMap.get('ScreenName');

  }

  ngOnInit(): void {

    this.getsubject(null,null);
    //this.getCode();
    this.ScreenName1==this.Activeroute.snapshot.paramMap.get('ScreenName');
  }

  getcodes:any;
  getCode()
  {
    this.service.GetCode({'Tablename':"SUBJECT_LEVEL_TYPE"}).subscribe((i:any)=>{
      this.getcodes=i;
    }, (error:any) => { console.log(error) }
    );
  }
  subject:any;
  getsubject(data:any,d:any){
    let ID:Number=0;
    if(data !=null){ID=Number(data.ID);}
    let list: any = {};
    list["currentNodeID"] = ID;
    list["screenName"] = 'STUDY UNIT';
    list["childRecordStatus"] = 'ALL';
    this.service.getSubjectTree(list).subscribe((i:any)=>{
      this.subject=i;

    // }).catch((e:any)=>{
    //   this.subject=null;
    // }
    // )
  }, error => {  console.log(error) }
  );
  }

  selectedsubject:any;
  ScreenName:any;
  SelectSubject(data:any){
     this.selectedsubject=data.target.value;
     this.StudyMaterialReportform.controls['MajorTopicID'].setValue('');
     this.getreport=null;
     this.getsubjectData(data.target.value,'MT')

  }
  getsubjectData(data:any,name:any,M?:any,C?:any,SC1?:any,SC2?:any,SC3?:any,SC4?:any,SC5?:any){


    let ID:Number=0;
    if(data !=null){ID=Number(data);}
    this.ScreenName=this.Activeroute.snapshot.paramMap.get('ScreenName');
    let list: any = {};
    if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='STUDY UNIT'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY UNIT';
      list["childRecordStatus"] = 'ALL';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='WIP'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'WIP';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Approved'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Approved';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Defer'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Defer';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rejected'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Rejected';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rework'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Rework';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Under Review'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Under Review';
    }
    else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Submitted'){
      //let list: any = {};
      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'Submitted';
    }
    else{

      list["currentNodeID"] = ID;
      list["screenName"] = 'STUDY MATERIAL';
      list["childRecordStatus"] = 'ALL';
    }

    this.service.getSubjectTree(list).subscribe((i:any)=>{

      if(name == 'MT'){
        this.MajorTopic=i;
        console.log(this.MajorTopic,'MajorTopic');
      }

    //   }).catch((e:any)=>{
    //   this.subject=null;
    // }
    // )
  }, (error:any) => { console.log(error) }
  );
  }

response:any;
getreport:any;

  Fetchreports(){
    this.Studymaterialreport=this.StudyMaterialReportform.value;
    this.Studymaterialreport.SessionLanguageTypeCode=this.appser.userlanuage;
    this.service.GetStudyMaterialReport(this.Studymaterialreport).subscribe((i:any)=>{
      this.response=i;
      this.getreport=this.response.data;
      console.log(this.getreport,'getreport')
    }, (error:any) => { console.log(error) }
    );
  }

  ActivityHistorypopupflag:boolean;

  Activityhistory(){
    this.Activityhistorypopup();
  }

  Activityhistorypopup(){
    this.ActivityHistorypopupflag=!this.ActivityHistorypopupflag;
    if(!this.ActivityHistorypopupflag){
      this.Fetchreports();
    }
  }

  currentrecord:any;
  currentstatus:any;
  Clickvalue(data:any,value:any,id:any){
    this.currentrecord=data;
    this.currentstatus=value;
    //if(id>1){
      var temp: StudyMaterialActivityHistory;

      temp = ({
        Subject_ID: this.StudyMaterialReportform.controls['SubjectID'].value,
        Study_Material_Status_Type_Code: value,
        SessionLanguageTypeCode: this.appser.userlanuage,
        Study_Unit_ID:data.Study_Unit_ID

      })
      this.StudyMaterialModel=temp;
      this.Activityhistory();
      this.getActivityhistory(this.StudyMaterialModel);
   // }
    // else{
    //   var temp: StudyMaterialActivityHistory;

    //   temp = ({
    //     Subject_ID: this.StudyMaterialReportform.controls['SubjectID'].value,
    //     Study_Material_Status_Type_Code: value,
    //     SessionLanguageTypeCode: this.appser.userlanuage,
    //     Study_Unit_ID:data.Study_Unit_ID

    //   })
    //   this.StudyMaterialModel=temp;

    //   this.getActivityhistory(this.StudyMaterialModel);


    // }

  }
  getvalue:any;
  ActivityHistorylist:any;
  status:any;
  StudyMaterialModel:any
  getActivityhistory(data:any){

    this.service.GetActivityHistory(data).subscribe((i:any)=>{
      this.getvalue=i;
      this.ActivityHistorylist=this.getvalue.Data;

      console.log(this.ActivityHistorylist);

    }, (error:any) => { console.log(error) }
    );
  }

  statuspopupflag:boolean;
Selectedstudymaterial:any
clickstatuspopup(data:any){
  this.Selectedstudymaterial=data;
  this.statuslistpopup();
}

statuslistpopup(){
  this.statuspopupflag=!this.statuspopupflag;
}

returnstatusclose(data:any){
  if(this.statuspopupflag){
    this.statuslistpopup();
  }
}

//Edit Functionality//
EditButton(data:any){
  this.Editstudymaterial(data);
  }
  CurrentstudyunitID:any;
StudyMaterialDetails:any;
Editstudymaterial(data:any){
   console.log(data,'Edit study unit');
   this.CurrentstudyunitID=data.Study_Unit_Id;
   this.StudyMaterialDetails=data;

   this.EditStudyMaterialpopup();
}

EditStudyMaterialflag:boolean
EditStudyMaterialpopup(){
  this.EditStudyMaterialflag=!this.EditStudyMaterialflag;
}

CloseandRefreshlist(data:any){

  if(this.EditStudyMaterialflag){
    this.EditStudyMaterialpopup();
    if(this.selectedsubject>0){
      var temp: StudyMaterialActivityHistory;

      temp = ({
        Subject_ID: this.StudyMaterialReportform.controls['SubjectID'].value,
        Study_Material_Status_Type_Code: this.currentstatus,
        SessionLanguageTypeCode: this.appser.userlanuage,
        Study_Unit_ID:this.currentrecord.Study_Unit_ID

      })
      this.StudyMaterialModel=temp;
      this.getActivityhistory(this.StudyMaterialModel)
    }
  }

  this.getStudyMaterial(this.CurrentstudyunitID);

}

selectedstudyunit:any;
studymaterialflag:boolean;
getStudyMaterial(Value?:Number){
  this.studymaterialflag=!this.studymaterialflag;
  if(this.studymaterialflag){
    if(Value!=null){

      this.StudyMaterial(Value);
     }
  }
  if(!this.studymaterialflag){
    this.selectedstudyunit=null;
    this.StudyMaterialresponse=null;
    if( this.CurrentlistId!=Number(Value)){
    if(Value!=null){

      this.StudyMaterial(Value);
     }
    }
  }



}

StudyMaterialresponse:any;
Search:any;
CurrentlistId:Number;
StudyMaterial(data:any)
{
  let ID:Number=0;
  if(data !=null){
    ID=Number(data);
  }
  this.CurrentlistId=ID;


  let list: any = {};
  if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='STUDY UNIT'){
    //let list: any = {};
    list["Study_Unit_Id"] = ID;
    list["StudyMaterialStatusTypeCode"] = 'ALL';
  }
  else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='WIP'){
    //let list: any = {};
    list["Study_Unit_Id"] = ID;
    list["StudyMaterialStatusTypeCode"] = 'WIP';
  }
  else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Approved'){
    //let list: any = {};
    list["Study_Unit_Id"] = ID;
    list["StudyMaterialStatusTypeCode"] = 'Approved';
  }
  else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Defer'){
    //let list: any = {};
    list["Study_Unit_Id"] = ID;
    list["StudyMaterialStatusTypeCode"] = 'Defer';
  }
  else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rejected'){
    //let list: any = {};
    list["Study_Unit_Id"] = ID;
    list["StudyMaterialStatusTypeCode"] = 'Rejected';
  }
  else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Rework'){
    //let list: any = {};
    list["Study_Unit_Id"] = ID;
    list["StudyMaterialStatusTypeCode"] = 'Rework';
  }
  else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Under Review'){
    //let list: any = {};
    list["Study_Unit_Id"] = ID;
    list["StudyMaterialStatusTypeCode"] = 'Under Review';
  }
  else if(this.Activeroute.snapshot.paramMap.get('ScreenName')=='Submitted'){
    //let list: any = {};
    list["Study_Unit_Id"] = ID;
    list["StudyMaterialStatusTypeCode"] = 'Submitted';
  }
  else{

    list["Study_Unit_Id"] = ID;
    list["StudyMaterialStatusTypeCode"] = 'ALL';
  }

    this.service.GetStudyMaterialList(list).subscribe((i:any)=>{
      this.Search=i;
      this.StudyMaterialresponse=this.Search.StudyMateriallist;
      this.selectedstudyunit=ID;
      console.log(this.StudyMaterialresponse);
//  }).catch((e:any)=>{
//    this.StudyMaterialresponse=e;
//  }
//  )
}, (error:any) => { console.log(error) }
);
}


 ReturnContentreviewclose(data:any){
  this.ClkContentclose();
  }

  Contentstatus:any;
selectedContentById:any;
Contenttext:string;
ClickContentstatus(data:any){
    this.selectedContentById=data.Content;
    this.Contentstatus=data.Content_status;
    this.Contenttext=data.Content_text;
    this.Contentreview();
  }

  Contentreviewpopupflag:boolean
Contentreview(){
this.Contentreviewpopupflag=!this.Contentreviewpopupflag;
}

ClkContentclose(){
  if(this.Contentreviewpopupflag){

    this.Contentreview();

  }
}


statusvalidate:any;
DefaultStatus:any;

CloseEditStudyMaterial(data:any){
  if(this.EditStudyMaterialflag){
  this.EditStudyMaterialpopup();
  if(this.selectedsubject>0){
    var temp: StudyMaterialActivityHistory;

    temp = ({
      Subject_ID: this.StudyMaterialReportform.controls['SubjectID'].value,
      Study_Material_Status_Type_Code: this.currentstatus,
      SessionLanguageTypeCode: this.appser.userlanuage,
      Study_Unit_ID:this.currentrecord.Study_Unit_ID

    })
    this.StudyMaterialModel=temp;
    this.getActivityhistory(this.StudyMaterialModel)
  }
}
}

studymateriallist1:any
  StudymaterialFormvalue1:any;
  contentreview(data:any){
    this.StudymaterialFormvalue1=data.Formvalue;
    this.studymateriallist1=data.StudyMateriallist;


    this.reviewpopup();
    if((data.StudyMateriallist.Study_Material_Status_Type_Code=='Submitted')||(data.StudyMateriallist.Study_Material_Status_Type_Code=='Under Review')){
       if(this.EditStudyMaterialflag){
          this.EditStudyMaterialpopup();
          if(this.selectedsubject>0){
            var temp: StudyMaterialActivityHistory;

            temp = ({
              Subject_ID: this.StudyMaterialReportform.controls['SubjectID'].value,
              Study_Material_Status_Type_Code: this.currentstatus,
              SessionLanguageTypeCode: this.appser.userlanuage,
              Study_Unit_ID:this.currentrecord.Study_Unit_ID

            })
            this.StudyMaterialModel=temp;
            this.getActivityhistory(this.StudyMaterialModel)
          }
        }
    }


  }

  reviewpopupflag:boolean
  reviewpopup(){
   this.reviewpopupflag=!this.reviewpopupflag;
  }
  studymateriallist:any
  StudymaterialFormvalue:any;
  contentpreview(data:any){
    this.StudymaterialFormvalue=data.Formvalue;
    this.studymateriallist=data.StudyMateriallist;



    this.previewpopup();
  }

  previewpopupflag:boolean
  previewpopup(){
   this.previewpopupflag=!this.previewpopupflag;
  }



    returnreviewpopup(data:any){
      if(this.previewpopupflag){
       this.Closepreview();
      }
      if(this.EditStudyMaterialflag){
       this.EditStudyMaterialpopup();
       if(this.selectedsubject>0){
        var temp: StudyMaterialActivityHistory;

            temp = ({
              Subject_ID: this.StudyMaterialReportform.controls['SubjectID'].value,
              Study_Material_Status_Type_Code: this.currentstatus,
              SessionLanguageTypeCode: this.appser.userlanuage,
              Study_Unit_ID:this.currentrecord.Study_Unit_ID

            })
            this.StudyMaterialModel=temp;
         this.getActivityhistory(this.StudyMaterialModel)
       }
      }
      if(this.reviewpopupflag){
       this.reviewpopup();
       if(this.selectedsubject>0){
        var temp: StudyMaterialActivityHistory;

            temp = ({
              Subject_ID: this.StudyMaterialReportform.controls['SubjectID'].value,
              Study_Material_Status_Type_Code: this.currentstatus,
              SessionLanguageTypeCode: this.appser.userlanuage,
              Study_Unit_ID:this.currentrecord.Study_Unit_ID

            })
            this.StudyMaterialModel=temp;
         this.getActivityhistory(this.StudyMaterialModel)
       }
      }
     }

     Closepreview(){
      this.previewpopup();
    }

    returnreviewclosebutton(data:any){
      if(this.reviewpopupflag){
      this.reviewpopup();
      if((ContentReviewcommentsComponent.currentstudymaterialstatus.Study_Material_Status_Type_Code=='Submitted')||(ContentReviewcommentsComponent.currentstudymaterialstatus.Study_Material_Status_Type_Code=='Under Review')){
        this.Editstudymaterial(ContentReviewcommentsComponent.currentstudymaterialstatus);
      }
      if(this.selectedsubject>0){
        var temp: StudyMaterialActivityHistory;

        temp = ({
          Subject_ID: this.StudyMaterialReportform.controls['SubjectID'].value,
          Study_Material_Status_Type_Code: this.currentstatus,
          SessionLanguageTypeCode: this.appser.userlanuage,
          Study_Unit_ID:this.currentrecord.Study_Unit_ID

        })
        this.StudyMaterialModel=temp;
        this.getActivityhistory(this.StudyMaterialModel)
      }

      console.log(ContentReviewcommentsComponent.currentstudymaterialstatus,'testglobal')
      }
    }
    returnclosebutton(data:any){
      if(this.previewpopupflag){
      this.previewpopup();
      }
    }

    validclosebutton:boolean=false;
    StudyUnitClose(data:any){
      //this.getsubjectdetails=false;
     this.validclosebutton=data;
    }


alertpopup:boolean;
AlertPopup(data:any){
  this.alertpopup=! this.alertpopup;
}

deletealertpopup:boolean;
DeleteAlertPopup(data:any){
  this.deletealertpopup=! this.deletealertpopup;
}
deletealertpopup1:boolean;
DeleteAlertPopup1(data:any){
  this.deletealertpopup1=! this.deletealertpopup1;
}
replacealertpopup:boolean;
ReplaceAlertPopup(data:any){
  this.replacealertpopup=! this.replacealertpopup;
}
CloseAlertpopup(){
  if(this.alertpopup){
    this.AlertPopup(1);
  }

  this.Close.next(1);
}
CloseDeleteAlertpopup(){
  if(this.deletealertpopup){
    this.DeleteAlertPopup(1);
  }

  this.Close1.next(1);
}
CloseDeleteAlertpopup1(){
  if(this.deletealertpopup1){
    this.DeleteAlertPopup1(1);
  }

  this.Closeclear.next(1);
}
CloseReplacealertpopup(){
  if(this.replacealertpopup){
    this.ReplaceAlertPopup(1);
  }
  this.Close.next(1);

}
replacebutton(){
  if(this.replacealertpopup){
    this.ReplaceAlertPopup(1);
  }
  this.Replace.next(1);
}
replacedeletebutton(){
  if(this.deletealertpopup){
    this.DeleteAlertPopup(1);
  }
  this.Replace1.next(1);

}
replacedeletebutton1(){
  if(this.deletealertpopup1){
    this.DeleteAlertPopup1(1);
  }
  this.Replaceclear.next(1);
}

CloseReviewContent(){
  console.log(ContentReviewcommentsComponent.currentstudymaterialstatus,'testglobal')

  this.reviewpopup();
  if((ContentReviewcommentsComponent.currentstudymaterialstatus.Study_Material_Status_Type_Code=='Submitted')||(ContentReviewcommentsComponent.currentstudymaterialstatus.Study_Material_Status_Type_Code=='Under Review')){
    this.Editstudymaterial(ContentReviewcommentsComponent.currentstudymaterialstatus);
  }

  console.log(ContentReviewcommentsComponent.currentstudymaterialstatus,'testglobal')
}


}

interface MajorTopic{
  ChildNodeExistInd:string;
  Study_Unit_Ind:string
  Data: any;
  Display_Order: Number;
  ID: Number;
  Name: string;
  Parent_Id:Number;
  Status_Code: string;
  Subject_Level_Type_Code: string;
}
